import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PAYMENT_DOCUMENT } from "./apiRoutes";

interface UseGetLineItemsByVendorIdProps {
  vendorId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getLineItemsByVendorId = async (vendorId: string) =>
  await axiosAuth.get(`${PAYMENT_DOCUMENT}/${vendorId}`);

const useGetLineItemsByVendorId = ({
  vendorId,
  queryParams,
}: UseGetLineItemsByVendorIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendor-payment", vendorId],
    queryFn: () => getLineItemsByVendorId(vendorId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetLineItemsByVendorId;
